<template>
    <section class="page-content">
        <TopBackgroundComponent/>
        <CoeDetailComponent/>
    </section>
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import CoeDetailComponent from '@/components/coe/CoeDetailComponent.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>